var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"thin-text"},[_c('translate',[_vm._v("VERSION")]),_vm._v(": "+_vm._s(_vm.version)+" ")],1)}
var staticRenderFns = []

export { render, staticRenderFns }